export const BASE_URL = "https://nobi-staging.onrender.com/api/v1";

export const Requests = {
  get: {
    getPackageCategories: "/categories",
    getownProfile: "/profiles/own-profile",
    getPrePackage: "/packages/pre-package",
    getPackageById: "/packages/pre-package/",
    platformFee: "/settings/platform-fee",
    specialOffers: "/special-offers",
    getPackage: "/packages",
    getOption: "/options",
    getBooking: "/bookings/all",
    getBookingFilter: "/bookings/filtered",
    getTransaction: "/transactions/all",
    getFinance: "/finance",
    getBankDetails: "/bankings",
    getWallet: "/wallets/my-wallet",
    getAvailability: "/packages/search-availability",
    getAllProviders: "/insurance-providers/all",
    getMyProviders: "/insurance-providers/my-provider",
    getAllOptions: "/options",
    getOptionById: "/options/packageId",
    getPreOptions: "/options/pre-options",
    getPackagesById: "/packages/",
    getFilteredSuppliers: "/auth/filter-suppliers",
  },

  post: {
    login: "/auth/login",
    signup: "/auth/create-account",
    requestPasswordReset: "/auth/send-reset-password-link",
    resetPassword: "/auth/reset-password",
    resendSignupOTP: "/auth/resend-signup-otp",
    resendRecoverOTP: "/auth/resend-password-reset-otp",
    createPackage: "/packages/",
    createCompany: "/profiles/",
    createPrePackage: "/packages/pre-package",
    confirmEmail: "/auth/confirm-email",
    userType: "/profiles",
    insuranceProvider: "/insurance-providers",
    authlogin: "/auth/auth0-login",
    specialOffers: "/special-offers",
    protocolService: "/protocol-services",
    applyfinanceSetting: "/finance/apply-finance-settings",
    bankDetail: "/bankings",
    addAvailability: "/packages/add-availability",
    createOption: "/options/create-option",
    createPreOptions: "/options/create-pre-options",
  },
  update: {
    createCompany: "/profiles",
    specialOffer: "/special-offers",
    specialOfferStatus: "/special-offers/change-status",
    declineBooking: "/bookings/cancel-booking",
    applyFinance: "finance/",
    bankingDetail: "/bankings",
    approvePackage: "/packages/approve",
    rejectPackage: "/packages/reject",
    updateProviders: "/insurance-providers",
    updateOption: "/options/update-option/",
    updatePackage: "/packages/edit-package/",
  },

  delete: {
    deleteSpecialOffer: "/special-offers",
    deletePackage: "/packages",
    deleteProviders: "/insurance-providers",
    deleteOption: "/options/delete-option/",
  },
};
